/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elevenlabs_Scribe_Limit_WarningInputs */

const en_elevenlabs_scribe_limit_warning = /** @type {(inputs: Elevenlabs_Scribe_Limit_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs Scribe only supports files up to 2 hours in length.`)
};

const fr_elevenlabs_scribe_limit_warning = /** @type {(inputs: Elevenlabs_Scribe_Limit_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs Scribe ne prend en charge que les fichiers d’une durée maximale de 2 heures.`)
};

const de_elevenlabs_scribe_limit_warning = /** @type {(inputs: Elevenlabs_Scribe_Limit_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs Scribe unterstützt nur Dateien mit einer Länge von bis zu 2 Stunden.`)
};

const it_elevenlabs_scribe_limit_warning = /** @type {(inputs: Elevenlabs_Scribe_Limit_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs Scribe supporta solo file lunghi fino a 2 ore.`)
};

const ru_elevenlabs_scribe_limit_warning = /** @type {(inputs: Elevenlabs_Scribe_Limit_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs Scribe поддерживает файлы продолжительностью до 2 часов.`)
};

const es_elevenlabs_scribe_limit_warning = /** @type {(inputs: Elevenlabs_Scribe_Limit_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs Scribe solo admite archivos de hasta 2 horas de duración.`)
};

const zh_cn2_elevenlabs_scribe_limit_warning = /** @type {(inputs: Elevenlabs_Scribe_Limit_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs Scribe 仅支持时长不超过 2 小时的文件。`)
};

const ja_elevenlabs_scribe_limit_warning = /** @type {(inputs: Elevenlabs_Scribe_Limit_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs Scribe は、最長 2 時間までのファイルのみをサポートします。`)
};

const hi_elevenlabs_scribe_limit_warning = /** @type {(inputs: Elevenlabs_Scribe_Limit_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs Scribe केवल 2 घंटे तक की लंबाई वाली फाइलों को ही सपोर्ट करता है।`)
};

const pt_pt2_elevenlabs_scribe_limit_warning = /** @type {(inputs: Elevenlabs_Scribe_Limit_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O ElevenLabs Scribe suporta apenas arquivos com duração de até 2 horas.`)
};

/**
* | output |
* | --- |
* | "ElevenLabs Scribe only supports files up to 2 hours in length." |
*
* @param {Elevenlabs_Scribe_Limit_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const elevenlabs_scribe_limit_warning = /** @type {((inputs?: Elevenlabs_Scribe_Limit_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elevenlabs_Scribe_Limit_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_elevenlabs_scribe_limit_warning(inputs)
	if (locale === "de") return de_elevenlabs_scribe_limit_warning(inputs)
	if (locale === "it") return it_elevenlabs_scribe_limit_warning(inputs)
	if (locale === "ru") return ru_elevenlabs_scribe_limit_warning(inputs)
	if (locale === "es") return es_elevenlabs_scribe_limit_warning(inputs)
	if (locale === "zh-CN") return zh_cn2_elevenlabs_scribe_limit_warning(inputs)
	if (locale === "ja") return ja_elevenlabs_scribe_limit_warning(inputs)
	if (locale === "hi") return hi_elevenlabs_scribe_limit_warning(inputs)
	if (locale === "pt-PT") return pt_pt2_elevenlabs_scribe_limit_warning(inputs)
	return en_elevenlabs_scribe_limit_warning(inputs)
});